// The parts of pdf.js' viewer CSS the text layer needs (selectable, invisible text over the canvas), plus search hits.
let done = false;
export function ensurePdfCss() {
  if (done || typeof document === 'undefined') return;
  done = true;
  const s = document.createElement('style');
  s.textContent = `
.rc-textLayer{position:absolute;inset:0;overflow:clip;line-height:1;text-align:initial;-webkit-text-size-adjust:none;text-size-adjust:none;transform-origin:0 0;z-index:1}
.rc-textLayer :is(span,br){color:transparent;position:absolute;white-space:pre;cursor:text;transform-origin:0% 0%}
.rc-textLayer span.markedContent{top:0;height:0}
.rc-textLayer ::selection{background:rgba(19,117,189,.35)}
.rc-textLayer .rc-hit{background:rgba(230,181,92,.45);border-radius:2px}
.rc-textLayer .endOfContent{display:block;position:absolute;inset:100% 0 0;z-index:0;cursor:default;user-select:none}`;
  document.head.appendChild(s);
}
